<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/SzbZKW/tc-custom/9780062378576.jpg?1718044369732" alt="This image is the cover for the book Booky Wook Collection"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Booky Wook Collection
      </h1>
      <p class="bookDescription body article font2">
        <p>“A child’s garden of vices, <i>My Booky Wook</i> is also a relentless ride with a comic mind clearly at the wheel.... The bloke can write. He rhapsodizes about heroin better than anyone since Jim Carroll. With the flick of his enviable pen, he can summarize childhood thus: ‘My very first utterance in life was not a single word, but a sentence. It was, ‘Don’t do that.’... Russell Brand has a compelling story." — <i>New York Times Book Review</i></p><p>The gleeful and candid <i>New York Times</i> bestselling autobiography of addiction, recovery, and rise to fame from Russell Brand, star of <i>Forgetting Sarah Marshall</i> and one of the biggest personalities in comedy today.</p><p>Picking up where he left off in <i>My Booky Wook</i>, movie star and comedian Russell Brand details his rapid climb to fame and fortune in a shockingly candid, resolutely funny, and unbelievably electrifying tell-all: Booky Wook 2. Brand’s performances in <i>Arthur</i>, <i>Get Him to the Greek</i>, and <i>Forgetting Sarah Marshall</i> have earned him a place in fans’ hearts; now, with a drop of Chelsea Handler’s <i>Chelsea Chelsea Bang Bang</i>, a dash of Tommy Lee’s <i>Dirt</i>, and a spoonful of Nikki Sixx’s <i>The Heroin Diaries</i>, Brand goes all the way—exposing the mad genius behind the audacious comic we all know (or think we know) and love (or at least, lust).</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Russell Brand
      </h2>
      
      <p class="authorDescription body article"><P>Russell Brand is a comedian, journalist, TV and radio presenter, and actor. He has won numerous awards including <I>Time Out</I>&#8217;s Comedian of the Year, Best Newcomer at the British Comedy Awards, Best TV Performer at the Broadcasting Press Guild Awards, and Most Stylish Man at <I>GQ</I>&#8217;s Men of the Year Awards. The first installment of his autobiography, <I>My Booky Wook</I>, was a <I>New York Times</I> bestseller. </P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      HarperCollinsPublishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?b67ec4a6